import * as React from 'react';
import { useSelector } from 'react-redux';

export interface TicketChannelProps {
  ticket: string;
  style?: React.CSSProperties;
}

export const TicketChannel = ({ ticket, style }: TicketChannelProps) => {
  const channel = useSelector<any>((state) => state.ticket.data[ticket]?.channel) as any;
  return (
    <div id="ticket_channel" style={style}>
      {channel}
    </div>
  );
};
